import { Agency } from './../models/agency.model';
import { Component, Input, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-organization-sd',
  template: `
    <app-json-ld [json]="schemaOrganization"></app-json-ld>
    <app-json-ld [json]="schemaWebsite"></app-json-ld>
  `
})
export class OrganizationSdComponent implements OnInit {
  @Input() agency: Agency;
  public schemaOrganization: any;
  public schemaWebsite: any;

  constructor(
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {

    if (this.agency) {

      this.schemaOrganization = {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        'name': this.agency.name,
        'url': this.document.location.origin,
        'contactPoint': [],
        'areaServed': 'RO',
        'sameAs': [
          this.agency.facebook_link,
          this.agency.instagram_link,
          this.agency.gplus_link,
          this.agency.pinterest_link,
          this.agency.youtube_link,
          this.agency.vimeo_link
        ]
      };

      if (this.agency.phone) {

        this.schemaOrganization['contactPoint'].push({
          '@type': 'ContactPoint',
          'telephone': this.agency.phone,
          'contactType': 'customer service',
          'availableLanguage': 'Romanian'
        });
      }

      if (this.agency.logo) {

        this.schemaOrganization['logo'] = this.agency.logo.url;
      }

      this.schemaWebsite = {
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        'name': this.agency.name,
        'url': this.document.location.origin
      };
    } else  {
      throw new Error('OrganizationSdComponent structured data error: Invalid agency');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/seo/organization-sd.component.ts